module.exports = __webpack_public_path__ + "img/15-3.6a8193aa.png";